import React from "react";
import AppBar from "../app-bar/app-bar";
import DistributorDetails from "../data-tables-pharmacy/distributor/distributor-details";
import {useUser} from "../providers/user-context";

function DistributorPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            <DistributorDetails navOpen={navOpen} tenantType={tenantType}/>
        </div>
    );
}
export default DistributorPage;
